import React, { useContext } from 'react';
import i18n from 'i18next';
import { AxiosResponse } from 'axios';
import { Namespace } from '../../../../../translation/namespace';
import { createFormElement } from '../../../../molecules/Form/FormFactory';
import { translatePartOfStringWithLink } from '../../../../../lib/StringUtils/StringHTMLUtils';
import LiveRegion from '../../../../atoms/LiveRegion/LiveRegion';
import { InteractionStatus } from '../../../../../types/InteractionStatus';
import { FormUtils, FormContext } from '../../../../molecules/Form';
import { FormSubmitButton } from '../../../../molecules/Form/components/FormSubmitButton/FormSubmitButton';
import { SonApiResponse } from '../../../../../types/api/SonApiResponse';

function getStatusMessages(response: AxiosResponse<SonApiResponse, any> | undefined) {
  if (response && response.data && response.data.url) {
    return {
      [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(
        translatePartOfStringWithLink(
          `${Namespace.PasswordReset}:reset.status.success`,
          response.data.url,
          false, // dont route here because we can get a url to keycloak page
        ),
        InteractionStatus.SUCCESS,
      ),
    };
  }
}

export default function PasswordResetTemplate() {
  const { inputs, onChange, submitActionEnabled, getStatus, response, hiddenFields } = useContext(FormContext);
  const labelHelpText = i18n.t('PasswordReset:labelHelpText');
  return (
    <>
      {hiddenFields}
      {createFormElement({ labelHelpText })(
        inputs.password,
        'resetPassword',
        onChange,
        i18n.t(`${Namespace.glossary}:password`),
      )}
      <FormSubmitButton buttonLabel={i18n.t(`${Namespace.glossary}:send`)} enabled={submitActionEnabled()} />
      <LiveRegion htmlTag="div" invisible={false} ariaAtomic ariaLive="polite">
        {getStatus(getStatusMessages(response))}
      </LiveRegion>
    </>
  );
}
